import React, { useState, useEffect, useRef, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { getClientDomain, getToken, translate, verifyHideCountryItems } from '../../../../utils/Common';
import AuthContext from '../../../../contexts/auth';
import ModalContext from '../../../../contexts/modal';
import { ToastContainer, useToast } from '../../../../components/common/Toast';
import ContentCard from '../../../../components/layout/ContentCard/ContentCard';
import QrCode from "qrcode.react";
import * as FaIcons from 'react-icons/fa';
import * as BsIcons from 'react-icons/bs';
import * as RiIcons from 'react-icons/ri';
import { verifyAccessViewPermissions } from '../../../../config/permissions';
import BtnSync from '../../../../components/BtnSync';
import styles from './PackageDetail.module.css';

// menu de paquetes
const PackageOptionPanel = ({ selectedPackage, onClickPanelOption, optionSelected, handleCancelBusqueda, getInfoPaquete, isMobile, handleOpenModalChangeClient }) => {
    const location = useLocation();
    const permissionsPath = '/dashboard/packages/tracking';
    const canUpdateReservationPackage = verifyAccessViewPermissions(['update-reservation-package'], { path: permissionsPath });
    const userContext = useContext(AuthContext);
    const modalContext = useContext(ModalContext);
    const userRole = JSON.parse(sessionStorage.getItem("user")).roleId;
    const idTipoLocker = selectedPackage?.IdTipoLocker ;
    const isAdmin = userContext.user?.IsAdmin;

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isActionsExpanded, setIsActionsExpanded] = useState(!isMobile);

    useEffect(() => {
        setIsActionsExpanded(!isMobile);
    }, [isMobile]);

    // panel opciones del menu
    const menuPanelOption = useRef();
    useEffect(() => {
        const handlerClosePanelOption = (e) => !menuPanelOption.current.contains(e.target) && setIsMenuOpen(false);

        window.addEventListener('mousedown', handlerClosePanelOption);
        
        return () => window.removeEventListener('mousedown', handlerClosePanelOption);
    }, []);

    // Confirmacion de opciones
    const handlerConfirmation = (option) => {
        switch (option) {
            case "RemoveReservation":
                if (!canUpdateReservationPackage) return;
                modalContext.confirm(
                    translate("global.alert.attention"),
                    <div className="p-0 mx-1">
                        <p className="m-2 p-0">{translate("dashboard.packages.details.optionPanel.removeReservation.cancelReservation")} <span className="font-semibold">{translate("global.door")} {selectedPackage?.Identificacion}</span>
                        {translate("components.packagesReservation.confirmReservation.address")} <span className="font-semibold">{selectedPackage?.Plataforma}</span>,
                        {translate("dashboard.packages.details.optionPanel.removeReservation.correspondingPackage")} <span className="font-semibold">{selectedPackage?.Nro_Id}</span>.</p>
                        <p className="mb-1 p-0">{translate("global.question.continue")}</p>
                    </div>,
                    [<button key={1} type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" onClick={ () => removeReservation(selectedPackage) }>{translate("global.yes")}</button>,
                    <button key={2} type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs border border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-secondary-foreground" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.no")}</button> ],
                    true);
                break;
            case "MakeReservation":
                if (!canUpdateReservationPackage) return;
                modalContext.confirm(
                    translate("global.alert.attention"),
                    <span>{translate("components.packagesReservation.confirmReservation.title")}
                        <span className="font-semibold"> {selectedPackage?.Nro_Id}</span>{translate("components.packagesReservation.confirmReservation.address")} 
                        <span className="font-semibold"> {selectedPackage?.Plataforma}</span> {translate("components.packagesReservation.confirmReservation.question")}
                    </span>,
                    [<button key={1} type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" onClick={ () => makeReservation(selectedPackage) }>{translate("global.yes")}</button>,
                    <button key={2} type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs border border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-secondary-foreground" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.no")}</button> ],
                    true);
                break;
            case "ForceDeliveryPackage":
                modalContext.confirm(
                    translate("global.alert.attention"),
                    <div className="p-0 mx-1">
                        <p className="m-0 p-0">{translate("global.aboutTo")} <span className="font-semibold">{translate("dashboard.packages.details.optionPanel.process")}</span> {translate("dashboard.packages.details.optionPanel.deliveryPackageNum")} <span className="font-semibold">{selectedPackage?.Nro_Id}</span>.</p>
                        <p className="mb-2 p-0">{translate("dashboard.packages.details.optionPanel.onceProcessed")} <span className="font-semibold">{translate("dashboard.packages.details.optionPanel.wontAbleTo")}</span> {translate("dashboard.packages.details.optionPanel.cancelDelivery")}</p>
                        <p className="mb-1 p-0">{translate("global.question.continue")}</p>
                    </div>,
                    [<button key={1} type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" onClick={ () => forceDeliveryPackage(selectedPackage) }>{translate("global.yes")}</button>,
                    <button key={2} type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs border border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-secondary-foreground" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.no")}</button> ],
                    true);
                break;
            case "RemovePackage":
                modalContext.confirm(
                    translate("global.alert.attention"),
                    <div className="p-0 mx-1">
                        <p className="m-0 p-0">{translate("global.aboutTo")} <span className="font-semibold">{translate("dashboard.packages.details.optionPanel.annul")}</span> {translate("dashboard.packages.details.optionPanel.packageNum")} <span className="font-semibold">{selectedPackage?.Nro_Id}</span>.</p>
                        <p className="mb-2 p-0">{translate("dashboard.packages.details.optionPanel.onceAnull")} <span className="font-semibold">{translate("dashboard.packages.details.optionPanel.wontAbleTo")}</span> {translate("dashboard.packages.details.optionPanel.restoreItAgain")}</p>
                        <p className="mb-1 p-0">{translate("global.question.continue")}</p>
                    </div>,
                    [<button key={1} type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" onClick={ () => removePackage(selectedPackage) }>{translate("global.yes")}</button>,
                    <button key={2} type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs border border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-secondary-foreground" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.no")}</button> ],
                    true);
                break;
                case "ChangeClient":
                        handleOpenModalChangeClient();
                    break;
            default:
                break;
        }
        onClickPanelOption(option);
    }

    // Manejar de reservaciones
    const makeReservation = async (paquete) => {
        try {
            if (!canUpdateReservationPackage) return;
            let dataToSend = {};

            dataToSend.numeroIdentificacion = paquete.Nro_Id;
            dataToSend.clasificacion = paquete.Clasificacion;
            dataToSend.idPlataforma = paquete.IdPlataforma;
            dataToSend.alto = paquete.Alto;
            dataToSend.ancho = paquete.Ancho;
            dataToSend.largo = paquete.Largo;
            modalContext.setIsOpenModal(false);

            const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/doors/reservation/add` , {
                method: 'POST',
                connection: 'keep-alive',
                accept: 'application/json',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                body: JSON.stringify(dataToSend)
            });
            const result = await response.json();
            if (result) {
                if (result.code === 200) {
                    if (result.payload) {
                        if (result.payload[0].Codigo === "1") {
                            getInfoPaquete(paquete);
                            modalContext.confirm(translate("global.modal.allReady"), 
                                <div className="mx-2 p-0">
                                    <p className="m-0 p-0 font-md">{translate("global.infoReservation")}:</p>
                                    <p className="m-0 p-0">{translate("dashboard.packages.details.numPackage")}: <span className="font-semibold">{paquete.Nro_Id}</span></p>
                                    <p className="m-0 p-0">{translate("global.doorAssign")}: <span className="font-semibold">{result.payload[0].Locker}</span></p>
                                    <p className="m-0 p-0">{translate("global.ubication")}: <span className="font-semibold">{paquete.Plataforma}</span></p>
                                </div>,
                                <button type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.accept")}</button>,
                                true);
                        }
                        else if (result.payload[0].Codigo === "2") 
                            modalContext.confirm(translate("global.alerts.ops"), 
                                <span>{translate("dashboard.packages.details.optionPanel.makeReservation.noDoorsAvailable")}</span>,
                                <button type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.accept")}</button>,
                                true);
                        else if (result.payload[0].Codigo === "3") 
                            modalContext.confirm(translate("global.alert.attention"), 
                                <span>{translate("dashboard.packages.details.optionPanel.makeReservation.sizePackage")}</span>,
                                <button type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.accept")}</button>,
                                true);
                        else if (result.payload[0].Codigo === "4") 
                            modalContext.confirm(translate("global.alert.attention"), 
                                <span>{translate("components.packagesReservation.NOT_DOORS_AVAILABLE")}</span>,
                                <button type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.accept")}</button>,
                                true);
                        else modalContext.confirm(translate("global.alert.attention"), 
                                <span>{translate("dashboard.packages.details.optionPanel.makeReservation.reservationActive")}</span>,
                                <button type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.accept")}</button>,
                                true);
                        
                    }
                }
                else if (result.error || result.code === 404 || result.code === 500) {
                    modalContext.confirm(translate("global.alerts.ops"), 
                        <span>{translate("dashboard.packages.details.optionPanel.makeReservation.error")}</span>,
                        <button type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.accept")}</button>,
                        true);
                }
            }
        } catch (error) {
            console.log(error);
            modalContext.confirm(translate("global.alerts.ops"), 
                <span>{translate("dashboard.packages.details.optionPanel.makeReservation.error")}</span>,
                <button type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.accept")}</button>,
                true);
        }
    }
    const removeReservation = async (paquete) => {
        try {
            if (!canUpdateReservationPackage) return;
            let dataToSend = {};
            
            dataToSend.idPaquete = paquete.IdPaquete;
            dataToSend.idPlataforma = paquete.IdPlataforma;
            modalContext.setIsOpenModal(false);

            const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/doors/reservation/remove` , {
                method: 'POST',
                connection: 'keep-alive',
                accept: 'application/json',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                body: JSON.stringify(dataToSend)
            });

            const result = await response.json();
            if (result) {
                if (!result.error) {
                    if (result.payload) {
                        if (result.payload[0].Codigo === "1") {
                            getInfoPaquete(paquete);
                            modalContext.confirm(translate("global.alert.ready"), 
                                        <span>{translate("dashboard.packages.details.optionPanel.removeReservation.package")} <span className="font-semibold">{`(${paquete.Nro_Id})` }</span> {translate("dashboard.packages.details.optionPanel.removeReservation.successfuly")}.</span>,
                                        <button type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.OK")}</button>,
                                        true);
                        }
                    }
                }
                if (result.error || result.code === 404 || result.code === 500) {
                    modalContext.confirm(translate("global.alerts.ops"), 
                        <span>{translate("dashboard.packages.details.optionPanel.makeReservation.error")}</span>,
                        <button type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.accept")}</button>,
                        true);
                }
            }
        } catch (error) {
            console.log(error);
            modalContext.confirm(translate("global.alerts.ops"), 
                <span>{translate("dashboard.packages.details.optionPanel.makeReservation.error")}</span>,
                <button type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.accept")}</button>,
                true);
        }
    }

    // Forzar {translate("global.delivery")} de paquete
    const forceDeliveryPackage = async (paquete) => {
        try {
            const abortController = new AbortController();
            let dataToSend = {};

            dataToSend.idPaquete = paquete.IdPaquete;
            dataToSend.idUsuario = paquete.IdUsuario;


            modalContext.setIsOpenModal(false);

            const response = await fetch(`${getClientDomain(2)}/dashboard/packages/forceDelivery` , {
                method: 'POST',
                connection: 'keep-alive',
                accept: 'application/json',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                body: JSON.stringify(dataToSend),
                signal: abortController.signal
            });
            const result = await response.json();
            if (result) {
                if (result.code === 200) {
                    if (result.payload) {
                        if (result.payload[0].Mensaje === 'PACKAGE_PROCESED') {
                            getInfoPaquete(paquete);
                            modalContext.confirm(translate("global.modal.allReady"), 
                                        <div className="mx-2 p-0">
                                            <p className="m-0 p-0">{translate("dashboard.packages.details.optionPanel.forceDeliveryPackage.package")} <span className="font-semibold">{paquete.Nro_Id}</span> ha sido procesado correctamente.</p>
                                        </div>,
                                        <button type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.accept")}</button>,
                                        true);
                        }else if (result.payload[0].Mensaje === "PLATFORM_INCORRECT") {
                            getInfoPaquete(paquete);
                            modalContext.confirm(translate("global.alerts.ops"), 
                                        <div className="mx-2 p-0">
                                            <p className="m-0 p-0">{translate("dashboard.packages.details.dropOff.receivePackage.PLATFORM_INCORRECT")}</p></div>,
                                        <button type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.accept")}</button>,
                                        true);
                        }
                        else {
                            modalContext.confirm(translate("global.alerts.ops"), 
                                <span>{translate("dashboard.packages.details.optionPanel.makeReservation.error")}</span>,
                                <button type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.accept")}</button>,
                                true);
                        }
                    }
                }
                if (result.error || result.code === 404 || result.code === 500) 
                    modalContext.confirm(translate("global.alerts.ops"), 
                        <span>{translate("dashboard.packages.details.optionPanel.makeReservation.error")}</span>,
                        <button type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.accept")}</button>,
                        true);
            }
        } catch (error) {
            console.log(error);
            modalContext.confirm(translate("global.alerts.ops"), 
                <span>{translate("dashboard.packages.details.optionPanel.makeReservation.error")}</span>,
                <button type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.accept")}</button>,
                true);
        }
    }
    
    // ANULAR un paquete
    const removePackage = async (paquete) => {
        try {
            modalContext.setIsOpenModal(false);

            const closeModal = () => {
                modalContext.setIsOpenModal(false);
                handleCancelBusqueda();
            }

            const response = await fetch(`${getClientDomain(2)}/dashboard/packages/delete` , {
                method: 'DELETE',
                connection: 'keep-alive',
                accept: 'application/json',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                body: JSON.stringify({ idPaquete: paquete?.IdPaquete, idPlataforma: paquete?.IdPlataforma })
            });

            const result = await response.json();
            if (result) {
                if (result.code === 200) {
                    if (result.payload) {
                        if (result.payload[0].Mensaje === 'PACKAGE_DELETED') {
                            modalContext.confirm(translate("global.alert.ready"), 
                                        <span>{translate("dashboard.packages.details.optionPanel.forceDeliveryPackage.package")} <span className="font-semibold">{ paquete.Nro_Id }</span> {translate("dashboard.packages.details.optionPanel.forceDeliveryPackage.null")}.</span>,
                                        <button type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" onClick={ () => closeModal() }>{translate("global.accept")}</button>,
                                        true);
                        }
                        else {
                            modalContext.confirm(translate("global.alert.somethingWrong"), 
                                        <span>{translate("dashboard.packages.details.optionPanel.forceDeliveryPackage.notNull")}.</span>,
                                        <button type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.accept")}</button>,
                                        true);
                        }
                    }
                }
                else if (result.error || result.code === 404 || result.code === 500) {
                    modalContext.confirm(translate("global.alerts.ops"), 
                        <span>{translate("dashboard.packages.details.optionPanel.makeReservation.error")}</span>,
                        <button type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.accept")}</button>,
                        true);
                }
            }
        } catch (error) {
            console.log(error);
            modalContext.confirm(translate("global.alerts.ops"), 
                <span>{translate("dashboard.packages.details.optionPanel.makeReservation.error")}</span>,
                <button type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.accept")}</button>,
                true);
        }
    }
    
    // ver qr code
    const handleShowQrCode = (paquete) => {
        const qrValue = paquete?.IdEstatus === 3 ? paquete?.Clave : paquete?.Nro_Id;
        modalContext.confirm(
            translate("global.codeQR"),
            <div className="p-0 mx-1 text-center">
                <QrCode id='packageQrCode' value={qrValue} renderAs={'canvas'} />
            </div>,
            <button key={2} type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90" onClick={ () => modalContext.setIsOpenModal(false) }>{translate("global.accept")}</button>,
            true);
    }

    // const printQrCode = () => {
    //     const svgQrCode = document.getElementById('packageQrCode');
    //     const qrCodeDataUri = svgQrCode.toDataURL('image/jpg', 0.3);
    //     console.log(qrCodeDataUri)
    // }

    const renderRemovePackageOption = () => {
        const canRemovePackage = verifyAccessViewPermissions(["delete"], { path: location.pathname });
        const isStatusTwoOrLess = selectedPackage?.IdEstatus <= 2;
        const isStatusThree = selectedPackage?.IdEstatus === 3;
        const isUserRoleThreeOrMore = userRole >= 3;
        const isUserRoleThree = userRole === 3;        
    
        const shouldShowRemovePackageOption = () => {
            if (!canRemovePackage) return false;
    
            // Caso: el paquete está en estado 2 o menos y el usuario es admin
            if (isStatusTwoOrLess) {
                if (isAdmin) return true; 
                return true
            }
    
            // Caso: el paquete está en estado 3 ("ON BOXIT")
            if (isStatusThree) {
                if (isUserRoleThree && idTipoLocker === 1) return true; // Usuario tipo Airfacilty
                if (isUserRoleThreeOrMore) return true;
            }
    
            // Por defecto, no mostrar opción
            return false;
        };
    
        return shouldShowRemovePackageOption() ? (
            <li className={styles.optionItem}
                style={{ padding: '0.75rem 1rem', textAlign: 'left', display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}
                onClick={() => handlerConfirmation("RemovePackage")}>
                <FaIcons.FaTrashAlt size={15} />
                <span className="ml-2">
                    {translate("dashboard.packages.details.optionPanel.unpack")}
                </span>
            </li>
        ) : null;
    };

    const syncOptions = (
        <div
            className={styles.actionButton}
            role="button"
            tabIndex={0}
            onClick={() => {
                const btnSyncRef = document.querySelector(`#btn-sync`);
                if (btnSyncRef) btnSyncRef.click();
            }}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    const btnSyncRef = document.querySelector(`#btn-sync`);
                    if (btnSyncRef) btnSyncRef.click();
                }
            }}
        >
            <span className={styles.actionButtonLeft}>
                <BtnSync size="sm" id="btn-sync" mode="package" packageId={selectedPackage?.IdPaquete} reservationId={selectedPackage?.ReservationIdGl} />
                <span>Sync</span>
            </span>
            <FaIcons.FaChevronRight className={styles.actionChevron} size={14} />
        </div>
    )

    const configOptionsPanel = {
            // Acciones principales al inicio: reservar / cambiar locker / sync
            1 : (
                canUpdateReservationPackage && 
                selectedPackage?.IdPlataforma !== 2 && 
                    (selectedPackage?.Identificacion ? 
                        ( selectedPackage?.IdEstatus <= 3 &&
                            <div
                                className={`${styles.actionButton} ${styles.actionButtonPrimary}`}
                                role="button"
                                tabIndex={0}
                                onClick={() => handlerConfirmation("RemoveReservation")}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        handlerConfirmation("RemoveReservation");
                                    }
                                }}
                            >
                                <span className={styles.actionButtonLeft}>
                                    <FaIcons.FaLock size={16} />
                                    <span>{translate("dashboard.packages.details.optionPanel.removeReservation") || 'Reserve door'}</span>
                                </span>
                                <FaIcons.FaChevronRight className={styles.actionChevron} size={14} />
                            </div>
                        )
                        :
                        <div
                            className={`${styles.actionButton} ${styles.actionButtonPrimary}`}
                            role="button"
                            tabIndex={0}
                            onClick={() => handlerConfirmation("MakeReservation")}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    handlerConfirmation("MakeReservation");
                                }
                            }}
                        >
                            <span className={styles.actionButtonLeft}>
                                <FaIcons.FaLock size={16} />
                                <span>{translate("dashboard.packages.details.optionPanel.reservationDoor") || 'Reserve door'}</span>
                            </span>
                            <FaIcons.FaChevronRight className={styles.actionChevron} size={14} />
                        </div>
                )
            ),
            2: (     
                verifyAccessViewPermissions(["update-change-platform"], { path: location.pathname }) && (selectedPackage?.IdEstatus !== 3 || isAdmin) &&
                <div
                    className={`${styles.actionButton} ${optionSelected === 'ChangePlatform' ? styles.actionButtonActive : ''}`}
                    role="button"
                    tabIndex={0}
                    onClick={() => onClickPanelOption(optionSelected === "ChangePlatform" ? "" : "ChangePlatform")}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            onClickPanelOption(optionSelected === "ChangePlatform" ? "" : "ChangePlatform");
                        }
                    }}
                >
                    <span className={styles.actionButtonLeft}>
                        <FaIcons.FaExchangeAlt size={16} />
                        <span>{translate("dashboard.packages.details.optionPanel.changePlatform") || 'Change locker'}</span>
                    </span>
                    <FaIcons.FaChevronRight className={styles.actionChevron} size={14} />
                </div>
            ),
            3 : (
                (verifyHideCountryItems(["pa"]) && userRole >= 5) && (syncOptions)
            ),
            // Acciones de edición / administración
            4 : (
                verifyAccessViewPermissions(["update"], { path: location.pathname }) && 
                    <div
                        className={`${styles.actionButton} ${optionSelected === 'ChangeInfo' ? styles.actionButtonActive : ''}`}
                        role="button"
                        tabIndex={0}
                        onClick={() => onClickPanelOption(optionSelected === "ChangeInfo" ? "" : "ChangeInfo")}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                onClickPanelOption(optionSelected === "ChangeInfo" ? "" : "ChangeInfo");
                            }
                        }}
                    >
                        <span className={styles.actionButtonLeft}>
                            <BsIcons.BsInfoCircleFill size={16}/>
                            <span>{translate("dashboard.packages.details.optionPanel.modifyInformation") || 'Update information'}</span>
                        </span>
                        <FaIcons.FaChevronRight className={styles.actionChevron} size={14} />
                    </div>
            ),
            5 : (
                verifyAccessViewPermissions(["update-package-expiration"], { path: location.pathname }) &&
                    (
                        <div
                            className={`${styles.actionButton} ${optionSelected === 'ChangeDateExpiration' ? styles.actionButtonActive : ''}`}
                            role="button"
                            tabIndex={0}
                            onClick={() => onClickPanelOption(optionSelected === "ChangeDateExpiration" ? "" : "ChangeDateExpiration")}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    onClickPanelOption(optionSelected === "ChangeDateExpiration" ? "" : "ChangeDateExpiration");
                                }
                            }}
                        >
                            <span className={styles.actionButtonLeft}>
                                <BsIcons.BsClockHistory size={16}/>
                                <span>{translate("global.updateDateExpiration") || 'Update expiration'}</span>
                            </span>
                            <FaIcons.FaChevronRight className={styles.actionChevron} size={14} />
                        </div>
                    )
            ),
            6 : (
                verifyAccessViewPermissions(["update-change-client"], { path: location.pathname }) && isAdmin && verifyHideCountryItems(["br"]) &&
                    (
                        <div
                            className={styles.actionButton}
                            role="button"
                            tabIndex={0}
                            onClick={() => handlerConfirmation("ChangeClient")}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    handlerConfirmation("ChangeClient");
                                }
                            }}
                        >
                            <span className={styles.actionButtonLeft}>
                                <BsIcons.BsPeopleFill size={16}/>
                                <span>{translate("global.changeClient") || 'Change client'}</span>
                            </span>
                            <FaIcons.FaChevronRight className={styles.actionChevron} size={14} />
                        </div>
                    )
            ),
            // Otras acciones
            7 : (
                verifyAccessViewPermissions(["read-qrcode"], { path: location.pathname }) && 
                <div
                    className={styles.actionButton}
                    role="button"
                    tabIndex={0}
                    onClick={() => handleShowQrCode(selectedPackage)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            handleShowQrCode(selectedPackage);
                        }
                    }}
                >
                    <span className={styles.actionButtonLeft}>
                        <FaIcons.FaQrcode size={16} />
                        <span>{translate("global.codeQR")}</span>
                    </span>
                    <FaIcons.FaChevronRight className={styles.actionChevron} size={14} />
                </div>
            ),
            8 : ( 
                verifyAccessViewPermissions(["update-force-delivery-package"], { path: location.pathname }) && ((selectedPackage?.IdEstatus === 2 && selectedPackage?.IdPlataformaDet) ||
                (selectedPackage?.IdEstatus === 1 && selectedPackage?.IdPlataforma === 2 )) &&
                <div
                    className={styles.actionButton}
                    role="button"
                    tabIndex={0}
                    onClick={() => handlerConfirmation("ForceDeliveryPackage")}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            handlerConfirmation("ForceDeliveryPackage");
                        }
                    }}
                >
                    <span className={styles.actionButtonLeft}>
                        <FaIcons.FaCheckCircle size={16}/>
                        <span>{translate("dashboard.packages.details.optionPanel.process")} {translate("global.delivery")}</span>
                    </span>
                    <FaIcons.FaChevronRight className={styles.actionChevron} size={14} />
                </div>
            ),
            9 : (
                renderRemovePackageOption() ? (
                    <button
                        type="button"
                        className={styles.actionDangerButton}
                        onClick={() => handlerConfirmation("RemovePackage")}
                    >
                        <FaIcons.FaTrashAlt size={16} />
                        <span>{translate("dashboard.packages.details.optionPanel.unpack") || 'Cancel package'}</span>
                    </button>
                ) : null
            )
    };

    const configStatusPackage = {
        // 1. NEW
        1 : (<>{configOptionsPanel[1]}{configOptionsPanel[2]}{configOptionsPanel[3]}{configOptionsPanel[4]}{configOptionsPanel[5]}{configOptionsPanel[6]}{configOptionsPanel[7]}{configOptionsPanel[9]}</>),
        // 2. RESERVED DOOR
        2 : (<>{configOptionsPanel[1]}{configOptionsPanel[2]}{configOptionsPanel[3]}{configOptionsPanel[4]}{configOptionsPanel[5]}{configOptionsPanel[6]}{configOptionsPanel[7]}{configOptionsPanel[8]}{configOptionsPanel[9]}</>),
        // 3. ON BOXIT
        3 : (<>{configOptionsPanel[2]}{configOptionsPanel[3]}{configOptionsPanel[4]}{configOptionsPanel[5]}{configOptionsPanel[6]}{configOptionsPanel[7]}{configOptionsPanel[9]}</>),
        // 4. RETIRED
        4 : (<>{configOptionsPanel[3]}{configOptionsPanel[7]}{configOptionsPanel[9]}</>),
        // 5. RETURNED
        5 : (<>{configOptionsPanel[2]}{configOptionsPanel[3]}{configOptionsPanel[4]}{configOptionsPanel[5]}{configOptionsPanel[6]}{configOptionsPanel[7]}{configOptionsPanel[9]}</>),
        // 6. ANULLED
        6 : (<>{configOptionsPanel[3]}{configOptionsPanel[7]}</>),
        // 7. IN TRANSIT
        7 : (<>{configOptionsPanel[2]}{configOptionsPanel[3]}{configOptionsPanel[4]}{configOptionsPanel[5]}{configOptionsPanel[7]}</>),
    }

    return (
        <ContentCard
            title={null}
            padding="md"
            className={styles.optionsPanel}
        >
            <div className={styles.actionsMenu} ref={menuPanelOption}>
                <div
                    className={`${styles.actionsHeader} ${isMobile ? styles.actionsHeaderToggle : ''}`}
                    role={isMobile ? 'button' : undefined}
                    tabIndex={isMobile ? 0 : undefined}
                    onClick={isMobile ? () => setIsActionsExpanded((prev) => !prev) : undefined}
                    onKeyDown={isMobile ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setIsActionsExpanded((prev) => !prev); } } : undefined}
                    aria-expanded={isMobile ? isActionsExpanded : undefined}
                >
                    <span className={styles.actionsHeaderLabel}>
                        <FaIcons.FaBolt size={14} className={styles.actionsHeaderIcon} aria-hidden />
                        {translate("dashboard.packages.details.optionPanel.actions") || 'Actions'}
                    </span>
                    {isMobile && (
                        <FaIcons.FaChevronDown className={`${styles.actionsHeaderChevron} ${isActionsExpanded ? styles.actionsHeaderChevronExpanded : ''}`} size={14} aria-hidden />
                    )}
                </div>

                {(!isMobile || isActionsExpanded) && (
                <>
                <div className={styles.actionsPrimary}>
                    {configOptionsPanel[1]}
                    {configOptionsPanel[2]}
                    {configOptionsPanel[3]}
                </div>

                <div className={styles.actionsSecondary}>
                    {configOptionsPanel[4]}
                    {configOptionsPanel[6]}
                    {configOptionsPanel[5]}
                    {configOptionsPanel[7]}
                    {configOptionsPanel[8]}
                </div>

                <div className={styles.actionsDanger}>
                    {configOptionsPanel[9]}
                </div>
                </>
                )}
            </div>
        </ContentCard>
    );
}

export default PackageOptionPanel;
